import { useContext } from "react";
import axios, { AxiosInstance } from "axios";
import { ProfileContext } from "../providers/profile";
import { useConfig } from "../config/useConfig";

export const useAxios = () => {
  const { accessToken } = useContext(ProfileContext);
  const { apiOrigin } = useConfig();

  const axiosHandler = (token?: any): AxiosInstance => {
    const instance = axios.create({
      baseURL: apiOrigin,
      timeout: 12000,
    });

    instance.interceptors.request.use(
      (config) => {
        if (!config) {
          config = {};
        }
        if (!config.headers) {
          config.headers = {};
        }
        config.headers.Authorization = `Bearer ${accessToken || token}`;
        return { ...config };
      },
      (error) => {
        return Promise.reject(error);
      }
    );
    return instance;
  };
  return { axiosHandler };
};
